import {useWebsiteConfigurationStore} from '~/stores/websiteConfigurationStore';

export default defineNuxtPlugin((nuxtApp) => {
  var mapKey = useRuntimeConfig().public.googleMapsKey;
  const websiteConfigurationStore = useWebsiteConfigurationStore();

  const thumbnailGenerator = {
    videoThumbnail: (guid) => {
      var code = parseInt(guid + '', 10).toString(36);
      let url = useRuntimeConfig().public.monthlyImagesProxyUrl + '../videos/' + code + '/thumb';
      return new URL(url).href;
    },

    imageThumbnail: (guid, size) => {
      let url = useRuntimeConfig().public.monthlyImagesProxyUrl + 'listing-feeds/' + websiteConfigurationStore.configuration.listingName + '/images/' + guid + '/' + size;
      return new URL(url).href;
    },
    youtubeThumbnail: (youtubeId, size = 'hqdefault') => {
      return 'https://img.youtube.com/vi/' + youtubeId + '/hqdefault.jpg';
    },
    mapThumbnail: (location, size = '600x300') => {
      var {latitude, longitude, zoom = 15} = location;
      return 'https://maps.googleapis.com/maps/api/staticmap?center='+latitude+','+longitude+'&zoom=15&scale=false&size='+size+'&maptype=roadmap&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff0000%7Clabel:1%7C'+latitude+','+longitude+'&key='+mapKey;
    },
    streetViewThumbnail: (location, size) => {
      var {latitude, longitude, heading, pitch} = location;
      return 'https://maps.googleapis.com/maps/api/streetview?size=' + size + '&location='+latitude+','+longitude+'&fov=90&heading=' + heading + '&pitch=' + pitch + '&key='+mapKey;
    },
    assetThumbnail: function(asset, size = '400x300') {
      if (asset.resource_type == 'videos') {
        var video = asset.resource;
        if (video.platform_type == 'youtube') {
          return 'https://img.youtube.com/vi/' + video.platform_video_id + '/hqdefault.jpg';
        }
      }
      if (asset.resource_type == 'digital-twins') {
        return 'https://public-images.monthly.cloud/matterport/' + asset.resource.code + '/thumb?width=600';
      }
      let url = useRuntimeConfig().public.monthlyImagesProxyUrl + 'listing-feeds/' + websiteConfigurationStore.configuration.listingName + '/assets/' + asset.id + '/' + size;
      return new URL(url).href;
    },
    getLocationIcon: function(location) {
      return (
        `https://images.flatcloud.app/listing-feeds/${websiteConfigurationStore.configuration.listingName}/locations/${location.geocode}`
      );
    },
    featureIcon: function(featureSlug) {
      // Remove prefix if starting with p. or c.
      let cleanSlug = featureSlug;
      if (featureSlug.startsWith('p.') || featureSlug.startsWith('c.')) {
        cleanSlug = featureSlug.substring(2);
      }
      return `https://public-images.monthly.cloud/icon-sets/flat-cloud/${cleanSlug}.svg`;
    },
    byType: function(type, resource, size = '400x300') {
      if (type == 'viewpoints') {
        var viewpoint = resource;
        if (viewpoint.view_types && viewpoint.view_types.includes('street_view')) {
          return this.streetViewThumbnail(
            {
              latitude: resource.position.latitude,
              longitude: resource.position.longitude,
              heading: resource.heading,
              pitch: resource.pitch
            },
            size
          );
        }
        if (viewpoint.image && viewpoint.image && viewpoint.image.guid) {
          return this.imageThumbnail(viewpoint.image.guid, size);
        }
      }
      if (type == 'videos') {
        var video = resource;
        if (video.platform_type == 'youtube') {
          return 'https://img.youtube.com/vi/' + video.platform_video_id + '/hqdefault.jpg';
        }
      }
      if (type == 'digital-twins') {
        return 'https://public-images.monthly.cloud/matterport/' + resource.code + '/thumb?width=600';
      }
      return this.imageThumbnail(resource.guid, size);
    }
  };

  // Here, we inject the `thumbnailGenerator` into the Nuxt app so it can be used globally.
  nuxtApp.provide('thumbnailGenerator', thumbnailGenerator);
});
